export const CREATE_NEW_GROWER = "Create new grower...";
export const FOLDER_TOKEN_PREFIX = "Folder Level ";